import { styled } from '@mui/material';
import { DAY_SIZE } from './Day.js';

const DatePickerWeekDayStyles = styled("div")(({ theme, $isSingleCalendar }) => ({
    ".react-datepicker__day": {
        "&-names": Object.assign({ display: "flex", alignItems: "flex-start", gap: $isSingleCalendar ? 4 : 1 }, ($isSingleCalendar && { justifyContent: "center" })),
        "&-name": Object.assign({ display: "flex", width: DAY_SIZE, padding: theme.spacing(1, 1.5), flexDirection: "column", justifyContent: "center", alignItems: "center", backgroundColor: theme.palette.ui20, color: theme.palette.text.greyLow }, theme.typography.tinyBold),
    },
}));

export { DatePickerWeekDayStyles };
//# sourceMappingURL=WeekDay.js.map
